import {RemoteGetRefundUserManualLink} from 'data/usecases/private/external-links/user-manual/remote-get-refund-user-manual';
import {GetRefundUserManualLink} from 'domain/usecases/private/external-links/user-manual/get-refund-user-manual';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators/authorize-http-client-decorator-factory';

import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetRefundUserManualLink = (): GetRefundUserManualLink =>
	new RemoteGetRefundUserManualLink(
		makeBFFApiUrl(ExternalLinkPoint.refundUserManual),
		makeAuthorizeHttpClientDecorator(),
	);
